module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "5%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "95%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/05_acknowledgements#acknowledgements",
      "id": "racknowledgements"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/06_introduction#introduction",
      "id": "rintroduction"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter1#ch01"
    }
  }, [_vm._v("  1")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_chapter1#ch01",
      "id": "rch01"
    }
  }, [_vm._v("Overlord")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter2#ch02"
    }
  }, [_vm._v("  2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter2#ch02",
      "id": "rch02"
    }
  }, [_vm._v("Beachhead Assault")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter3#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter3#ch03",
      "id": "rch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attritional Battles in the Bridgehead – June")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter4#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter4#ch04",
      "id": "rch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War of Attrition Continues – July")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter5#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter5#ch05",
      "id": "rch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August Break-out")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter6#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter6#ch06",
      "id": "rch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Neptune and the Great Swan")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter7#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter7#ch07",
      "id": "rch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Garden")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter8#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter8#ch08",
      "id": "rch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Long Hard Winter – the Maas and Peel Country")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter9#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter9#ch09",
      "id": "rch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ardennes")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter10#ch10",
      "id": "rch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Siegfried Line: the Reichwald Battles")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter11#ch11",
      "id": "rch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Rhine to the Baltic: ‘Twilight of the Gods’")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_envoi#envoi",
      "id": "renvoi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Envoi")])])]), _vm._v(" "), _c('tr', {
    staticClass: "spaceUper"
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_index#index",
      "id": "rindex",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a20273","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_contents.vue
// module id = 66
// module chunks = 0